/* eslint-disable */
export default {
  dncAlert: 'Ce contact est sur une liste Ne pas appeler.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
